import React, { useState, FC } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Button from '@atlaskit/button';
import { PurgeTeamRequest } from '@atlassiansox/phobos-client-ts';

import { apis, apiResolve } from '@/services';
import { Confirm } from '@/components/composed';
import { useFetchErrorController } from '@/controllers';

import { purgeButtonContainer } from './styles';

type TeamPurgeProps = {
  publicId: string;
};

const TeamPurge: FC<TeamPurgeProps> = ({ publicId }) => {
  const { onError } = useFetchErrorController();

  const [isPurgeLoading, setIsPurgeLoading] = useState<boolean>(false);
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (request: PurgeTeamRequest) => apiResolve(apis.team.purgeTeam(request)),
    {
      onError,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['team'] });
      },
      onSettled: () => {
        setIsPurgeLoading(false);
      },
    }
  );
  const handlePurge = async () => {
    const verify: boolean = await Confirm({
      body: (
        <>
          Please confirm you want to delete the entire <b>team</b> with all the <b>capabilities</b>,
          <b>SLOs</b> and <b>products</b> linked to this team.
        </>
      ),
    });
    if (!verify) return;

    setIsPurgeLoading(true);
    mutation.mutate({ publicId: publicId as string });
  };

  return (
    <div css={purgeButtonContainer}>
      <Button appearance="warning" onClick={handlePurge}>
        {isPurgeLoading ? 'Purging...' : 'Purge team'}
      </Button>
    </div>
  );
};

export default TeamPurge;
